module Client.ValidationInfrastructure

let bundleValidations getter count (validations: 'v list) =
    let accum = Array.init count (fun _ -> [])
    let addToAcc index str (acc: string list []) = 
        acc.[index] <- str::acc.[index]
        acc
    validations
    |> List.fold (fun acc v ->
        let index, str = getter v
        addToAcc index str acc
    ) accum
    |> Array.map Illy.SafeStack.CompositionalValidation.concatOptional     